import { render } from "./partner.vue?vue&type=template&id=4b483dc0&bindings={\"navigate\":\"props\"}"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./partner.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script